<template>
    <div class="checkout__accordion" v-if="!hide">
        <a
            href="#"
            class="checkout__accordion__title checkout__accordion__title--done"
            v-if="completed"
            @click="edit"
            >{{ __("Ticket") }}</a
        >
        <span class="checkout__accordion__title" v-else-if="!completed">{{ __("Ticket") }}</span>
        <div class="checkout__block" v-if="!completed">
            <form class="form">
                <div class="flex flex-col md:flex-row gap-4">
                    <div
                        class="p-4 lg:p-8 md:w-1/3 text-center bg-gray-100 flex flex-col items-center border border-gray-300"
                        v-if="tickets.includes('eticket') && tenantId !== 51 && ticketPrintingOptions == false"
                    >
                        <svg viewBox="-120 0 480 480" width="50px" height="50px" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="m200 0h-160c-22.082031.0273438-39.9726562 17.917969-40 40v400c.0273438 22.082031 17.917969 39.972656 40 40h160c22.082031-.027344 39.972656-17.917969 40-40v-400c-.027344-22.082031-17.917969-39.9726562-40-40zm-184 248h32v-16h-32v-152h208v152h-32v16h32v120h-208zm24-232h160c13.253906 0 24 10.746094 24 24v24h-208v-24c0-13.253906 10.746094-24 24-24zm160 448h-160c-13.253906 0-24-10.746094-24-24v-56h208v56c0 13.253906-10.746094 24-24 24zm0 0"
                            />
                            <path
                                d="m120 400c-13.253906 0-24 10.746094-24 24s10.746094 24 24 24 24-10.746094 24-24-10.746094-24-24-24zm0 32c-4.417969 0-8-3.582031-8-8s3.582031-8 8-8 8 3.582031 8 8-3.582031 8-8 8zm0 0"
                            />
                            <path d="m104 32h64v16h-64zm0 0" />
                            <path d="m72 32h16v16h-16zm0 0" />
                            <path d="m48 112h24v-16h-40v40h16zm0 0" />
                            <path d="m192 136h16v-40h-40v16h24zm0 0" />
                            <path d="m48 312h-16v40h40v-16h-24zm0 0" />
                            <path d="m192 336h-24v16h40v-40h-16zm0 0" />
                            <path d="m112 128h-48v48h48zm-16 32h-16v-16h16zm0 0" />
                            <path d="m64 320h48v-48h-48zm16-32h16v16h-16zm0 0" />
                            <path d="m128 128h16v16h-16zm0 0" />
                            <path d="m144 176h16v40h-24v40h16v-24h24v-104h-16v32h-32v32h16zm0 0" />
                            <path d="m64 240h56v16h-56zm0 0" />
                            <path d="m176 272h-48v48h16v-32h32zm0 0" />
                            <path d="m160 304h16v16h-16zm0 0" />
                            <path d="m64 192v32h48v-32h-16v16h-16v-16zm0 0" />
                        </svg>
                        <div class="mt-4">
                            {{ __("Paperless ticket") }}
                        </div>
                        <div>({{ __("No additional charge") }})</div>
                        <div class="flex-1"></div>
                        <a
                            href="#"
                            class="btn btn--secondary mt10 btn-paperless-ticket"
                            @click="save($event, 'eticket')"
                            >Choose</a
                        >
                    </div>
                    <div
                        class="p-4 lg:p-8 md:w-1/3 text-center bg-gray-100 flex flex-col items-center border border-gray-300"
                        v-if="tickets.includes('printed') && forceCollection === false"
                    >
                        <svg
                            version="1.1"
                            width="50px"
                            height="50px"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            viewBox="0 0 60 60"
                            style="enable-background:new 0 0 60 60;"
                            xml:space="preserve"
                        >
                            <g>
                                <path
                                    d="M50,32c2.757,0,5-2.243,5-5s-2.243-5-5-5s-5,2.243-5,5S47.243,32,50,32z M50,24c1.654,0,3,1.346,3,3s-1.346,3-3,3
s-3-1.346-3-3S48.346,24,50,24z"
                                />
                                <path
                                    d="M42,43H18c-0.553,0-1,0.447-1,1s0.447,1,1,1h24c0.553,0,1-0.447,1-1S42.553,43,42,43z"
                                />
                                <path
                                    d="M42,48H18c-0.553,0-1,0.447-1,1s0.447,1,1,1h24c0.553,0,1-0.447,1-1S42.553,48,42,48z"
                                />
                                <path
                                    d="M51,17V0H9v17H0v34h6v3h3v6h42v-6h3v-3h6V17H51z M11,2h38v15H11V2z M9,19h42h7v16H2V19H9z M8,52v-2v-1v-4
c0-0.553-0.447-1-1-1s-1,0.447-1,1v4H2V37h7v15H8z M49,58H11v-4V37h38v17V58z M54,49v-4c0-0.553-0.447-1-1-1s-1,0.447-1,1v4v1v2h-1
V37h7v12H54z"
                                />
                            </g>
                        </svg>
                        <div class="mt-4">{{ __("Printed ticket") }} (Delivery)</div>
                        <div>
                            <template v-if="printCharge != '0'">(+ {{ printCharge }}) {{ __("per ticket") }}</template>
                            <template v-if="deliveryCharge != '0'">
                                <template v-if="printCharge != '0'"> &amp; </template>
                                {{ deliveryCharge + " " + __("delivery charge per order") }}
                            </template>
                        </div>
                        <div class="flex-1"></div>
                        <a href="#" class="btn  btn--secondary mt10" @click="save($event, 'printed')">Choose</a>
                    </div>
                    <div
                        class="p-4 lg:p-8 md:w-1/3 text-center bg-gray-100 flex flex-col items-center border border-gray-300"
                        v-if="true || offerCollection"
                    >
                        <svg
                            version="1.1"
                            width="50px"
                            height="50px"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            viewBox="0 0 60 60"
                            style="enable-background:new 0 0 60 60;"
                            xml:space="preserve"
                        >
                            <g>
                                <path
                                    d="M50,32c2.757,0,5-2.243,5-5s-2.243-5-5-5s-5,2.243-5,5S47.243,32,50,32z M50,24c1.654,0,3,1.346,3,3s-1.346,3-3,3
s-3-1.346-3-3S48.346,24,50,24z"
                                />
                                <path
                                    d="M42,43H18c-0.553,0-1,0.447-1,1s0.447,1,1,1h24c0.553,0,1-0.447,1-1S42.553,43,42,43z"
                                />
                                <path
                                    d="M42,48H18c-0.553,0-1,0.447-1,1s0.447,1,1,1h24c0.553,0,1-0.447,1-1S42.553,48,42,48z"
                                />
                                <path
                                    d="M51,17V0H9v17H0v34h6v3h3v6h42v-6h3v-3h6V17H51z M11,2h38v15H11V2z M9,19h42h7v16H2V19H9z M8,52v-2v-1v-4
c0-0.553-0.447-1-1-1s-1,0.447-1,1v4H2V37h7v15H8z M49,58H11v-4V37h38v17V58z M54,49v-4c0-0.553-0.447-1-1-1s-1,0.447-1,1v4v1v2h-1
V37h7v12H54z"
                                />
                            </g>
                        </svg>
                        <div class="mt-4">{{ __("Printed ticket") }} (Collection)</div>
                        <div>{{ collectionInstructions }}</div>
                        <div class="flex-1"></div>
                        <a href="#" class="btn  btn--secondary mt10" @click="save($event, 'printed_collection')"
                            >Choose</a
                        >
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        completed: {
            type: Boolean,
            required: true
        },
        tenantId: {
            type: Number,
            required: true
        },
        offerCollection: {
            type: Boolean,
            required: true
        },
        collectionInstructions: {
            required: false,
            default: function() {
                return null;
            }
        },
        forceCollection: {
            type: Boolean,
            required: true
        },
        ticketPrintingOptions: {
            required: true
        },
        printCharge: {
            required: true
        },
        deliveryCharge: {
            required: true
        }
    },

    data: () => ({
        hide: false,
        tickets: [],
        ticket: "",
        errors: {},
        reservations: false
    }),

    mounted() {
        this.$emit("loading", true);

        axios.get("/checkout/tickets").then(response => {
            this.hide = true;
            this.tickets = response.data;
            if (this.tickets.length == 1) {
                this.$emit("loading", false);
                this.$emit("update", this.tickets[0]);
                this.$emit("next");
            } else {
                this.$emit("loading", false);
                this.summary();
                this.hide = false;
            }
        });
    },

    methods: {
        summary() {
            axios.get("/checkout/summary").then(response => {
                this.reservations = typeof response.data.order !== "undefined" ? response.data.order.lines : [];

                // Hide printed tickets if it's shop items only
                var tickets = this.reservations.filter(line => {
                    if (line.event_schedule_id > -1) {
                        return line;
                    }
                });

                if (tickets.length == 0) {
                    this.hide = true;
                    this.ticket = "";
                    this.$emit("update", this.ticket);
                    this.$emit("next");
                }
            });
        },
        save(event, ticket) {
            event.preventDefault();

            this.$emit("loading", true);

            axios
                .post("/checkout/ticket", {
                    ticket: ticket
                })
                .then(() => {
                    this.ticket = ticket;
                    this.$emit("update", this.ticket);
                    this.$emit("next");
                });
        },

        edit() {
            event.preventDefault();

            this.ticket = "";
            this.$emit("edit", true);
        }
    },

    watch: {}
};
</script>



// WEBPACK FOOTER //
// resources/js/components/Checkout/Tickets.vue